import { Component } from '@angular/core';

@Component({
  selector: 'holding-container',
  templateUrl: './holding-container.component.html',
  styleUrls: ['./holding-container.component.css']
})
export class HoldingContainerComponent {

}
